import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private hasShownReloadModal = false;

  handleError(error: any): void {
    const chunkFailedPattern =
      /Loading chunk|Failed to fetch dynamically imported module/;

    if (chunkFailedPattern.test(error?.message) && !this.hasShownReloadModal) {
      this.hasShownReloadModal = true;
      this.showReloadModal();
    }

    // Still log error for debugging
    console.error('Global Error:', error);
  }

  private showReloadModal(): void {
    // Create modal using vanilla DOM - no Angular/PrimeNG dependencies
    // This ensures the modal works even if lazy-loaded chunks fail
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed; inset: 0; z-index: 10000;
      background: rgba(0,0,0,0.5);
      display: flex; align-items: center; justify-content: center;
    `;

    const modal = document.createElement('div');
    modal.style.cssText = `
      background: white; padding: 2rem; border-radius: 8px;
      max-width: 400px; text-align: center; box-shadow: 0 4px 20px rgba(0,0,0,0.3);
    `;
    modal.innerHTML = `
      <h2 style="margin: 0 0 1rem; color: #333;">Update Required</h2>
      <p style="margin: 0 0 1.5rem; color: #666;">
        A new version of the application is available. Please reload to continue.
      </p>
      <button id="reload-btn" style="
        background: #3B82F6; color: white; border: none;
        padding: 0.75rem 1.5rem; border-radius: 4px;
        font-size: 1rem; cursor: pointer;
      ">Reload Now</button>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    document.getElementById('reload-btn')?.addEventListener('click', () => {
      window.location.reload();
    });
  }
}
